import React from 'react';

export const BackgroundVideo: React.FC = (): JSX.Element | null => {
  return (
    <video className='background-video' autoPlay loop muted={true} playsInline>
      <source src="https://media.openexc.com/wp-content/uploads/2023/10/samsung_login_1080p.mp4" type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  );
};